import { render, staticRenderFns } from "./menuCenternInfo.vue?vue&type=template&id=c435dda2&scoped=true"
import script from "./menuCenternInfo.vue?vue&type=script&lang=js"
export * from "./menuCenternInfo.vue?vue&type=script&lang=js"
import style0 from "./menuCenternInfo.vue?vue&type=style&index=0&id=c435dda2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c435dda2",
  null
  
)

export default component.exports